import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeAllCountriesList } from './normalize';

export const fetchAllCountriesList = createProvider(api.fetchAllCountriesList)
  .andThen((res) => normalizeAllCountriesList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
